module.exports = __webpack_public_path__ + "static/media/momo-yaoyorozu.86ba3ffa.png";